import React, { useMemo, useCallback } from 'react';
import ChaserStyledSelect from '../../../../../components/ChaserStyledSelect';

// @see csvMappingConfigurationSchema.fieldSeparator field in chaser-models/src/models/Organisation.ts
const AVAILABLE_FIELD_SEPARATORS = [
  { value: 'COMMA', label: ', (comma)' },
  { value: 'SEMICOLON', label: '; (semicolon)' },
  { value: 'TAB', label: '\\t (tab)' },
  { value: 'PIPE', label: '| (pipe)' },
];

export const GeneralConfigurationFieldSeparatorSelect = ({
  value,
  onChange,
  containerStyles,
  name,
}) => {
  const fieldSeparators = AVAILABLE_FIELD_SEPARATORS;

  const selectedFieldSeparator = useMemo(() => {
    return fieldSeparators.find(({ value: v }) => v === (value || 'COMMA'));
  }, [value, fieldSeparators]);

  const handleOnChange = useCallback(
    value => {
      onChange({
        target: {
          name,
          value: value.value,
        },
      });
    },
    [onChange, name],
  );

  return (
    <ChaserStyledSelect
      value={selectedFieldSeparator}
      onChange={handleOnChange}
      options={fieldSeparators}
      containerStyles={containerStyles}
      name={name}
    />
  );
};
